import { WSAlert, WSMarginProps } from "@wingspanhq/fe-component-library";
import React from "react";

type Props = {} & WSMarginProps;

export const AlertClientNotAllowedSubmission: React.FC<Props> = props => {
  return (
    <WSAlert
      theme="info"
      icon="info-circle"
      title="Client does not allow invoice submissions"
      {...props}
    >
      Only the client can create invoices on your behalf for this engagement.
    </WSAlert>
  );
};
